<form
  class="store-form"
  [formGroup]="storeSettingsForm"
  (ngSubmit)="handleSave()"
>
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Store Profile</span>
      <h3>Business Identity</h3>
      <p>
        Manage the public store name, URL slug, and customer-facing description.
      </p>
    </div>

    <div class="form-grid">
      <label class="field">
        <span>Store Name *</span>
        <input
          type="text"
          formControlName="business_name"
          placeholder="Soho Studio"
          [class.is-invalid]="isInvalid('business_name')"
        />

        @if (isInvalid("business_name")) {
          <small>Store name is required.</small>
        }
      </label>

      <label class="field">
        <span>Store URL *</span>

        <div class="slug-control" [class.is-invalid]="isInvalid('userName')">
          <span>gloget.com/</span>
          <input
            type="text"
            formControlName="userName"
            placeholder="sohostudio"
          />
        </div>

        @if (isInvalid("userName")) {
          <small>Username is required.</small>
        }
      </label>

      <label class="field">
        <span>Description *</span>
        <textarea
          rows="5"
          formControlName="description"
          placeholder="Describe your salon, services, style, and customer experience..."
          [class.is-invalid]="isInvalid('description')"
        ></textarea>

        @if (isInvalid("description")) {
          <small>Description is required.</small>
        }
      </label>
    </div>
  </section>

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Media</span>
      <h3>Logo & Photos</h3>
      <p>
        Upload your logo and a small photo collection to support your public
        listing.
      </p>
    </div>

    <div class="media-grid">
      <div class="media-block">
        <div class="media-head">
          <strong>Company Logo</strong>
          <span>SVG, PNG, or JPG. Max 5MB.</span>
        </div>

        <input
          #logoInput
          type="file"
          class="hidden"
          accept="image/*"
          (change)="onLogoSelected($event)"
        />

        <div class="upload-row">
          @if (logoPreview) {
            <div class="logo-preview">
              <img [src]="logoPreview" alt="Company logo" />

              <button type="button" (click)="removeLogo()">×</button>
            </div>
          }

          <button
            type="button"
            class="upload-box"
            (click)="triggerLogoUpload()"
          >
            <img [src]="assetUrl + 'icons/upload-border.svg'" alt="" />
            <span>
              <strong>Click to upload</strong>
              or drag and drop
            </span>
          </button>
        </div>
      </div>

      <div class="media-block">
        <div class="media-head">
          <strong>Photo Collection</strong>
          <span>{{ photoPreviews.length }} / {{ MAX_PHOTOS }} uploaded</span>
        </div>

        <input
          #photosInput
          type="file"
          class="hidden"
          multiple
          accept="image/*"
          (change)="onPhotosSelected($event)"
        />

        <div class="photo-grid">
          @for (photo of photoPreviews; track photo; let i = $index) {
            <div class="photo-preview">
              <img [src]="photo" alt="Store photo" />

              <button type="button" (click)="removePhoto(i)">×</button>
            </div>
          }

          @if (photoPreviews.length < MAX_PHOTOS) {
            <button
              type="button"
              class="photo-add"
              (click)="triggerPhotosUpload()"
            >
              <img [src]="assetUrl + 'icons/img-upload.svg'" alt="" />
            </button>
          }
        </div>
      </div>
    </div>
  </section>

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Branding</span>
      <h3>Brand Placement</h3>
      <p>Choose where your business logo should be displayed.</p>
    </div>

    <div class="checkbox-grid">
      <label class="checkbox-card">
        <input type="checkbox" formControlName="logo_in_repost" />

        <div>
          <strong>Reports</strong>
          <span>Include my logo in summary reports.</span>
        </div>
      </label>

      <label class="checkbox-card">
        <input type="checkbox" formControlName="logo_in_emails" />

        <div>
          <strong>Emails</strong>
          <span>Include my logo in customer emails.</span>
        </div>
      </label>
    </div>
  </section>

  <div class="form-footer">
    <button type="button" class="light-btn" (click)="resetForm()">
      Cancel
    </button>

    <button type="submit" class="dark-btn" [disabled]="isLoading">
      {{ isLoading ? "Saving..." : "Save Changes" }}
    </button>
  </div>
</form>
